import * as React from 'react';
import { api, handleApiError } from 'services/api';

export const useDeleteEquipment = () => {
  const deleteEquipment = React.useCallback(async (id: string | number) => {
    try {
      await api.delete<void>(`equipments/${id}`);
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { deleteEquipment };
};